import { BaseModel } from '../common/base-model/base-model';

export class AttendantServices extends BaseModel {
  constructor(
    public override id?: string,
    public attendant_id?: string,
    public service_id?: string,
    public deleted?: boolean,
  ) {
    super();
  }

  toJSON() {
    return {
      id: this.id,
      attendant_id: this.attendant_id,
      service_id: this.service_id,
      deleted: !!this.deleted,
    };
  }

  static fromJson(jsonData: any): AttendantServices {
    return Object.assign(new AttendantServices(), jsonData);
  }
}
